import React from 'react';
const testimonials = [{
  name: 'Markus W.',
  role: 'Cheftrainer U18, TSV München',
  initials: 'MW',
  text: 'Ich habe in der ersten Woche schon 4 Stunden gespart. Die Trainingspläne sind so durchdacht, dass ich abends nur noch das Tablet öffne und loslegen kann. Meine Spieler haben sofort den Unterschied bemerkt.',
  rating: 5,
  color: 'from-blue-500/20 to-blue-600/5',
  accent: 'border-blue-500/30'
}, {
  name: 'Sandra K.',
  role: 'Trainerin Damen Verbandsliga, Hamburg',
  initials: 'SK',
  text: 'Die Saisonplanung hat mein Coaching komplett verändert. Endlich habe ich eine klare Struktur statt Chaos. Die Drills sind direkt einsetzbar und meine Mannschaft macht messbare Fortschritte.',
  rating: 5,
  color: 'from-secondary/20 to-yellow-500/5',
  accent: 'border-secondary/30'
}, {
  name: 'Thomas B.',
  role: 'Jugendtrainer, VC Berlin',
  initials: 'TB',
  text: 'Als Quereinsteiger war ich überfordert. Mit Volleyball Bereit hatte ich nach 5 Minuten einen kompletten Wochenplan. Die Methodik EDULABS™ ist einfach Gold wert für jeden Trainer.',
  rating: 5,
  color: 'from-cta-green/20 to-green-600/5',
  accent: 'border-cta-green/30'
}, {
  name: 'Julia R.',
  role: 'Cheftrainerin U16, Köln',
  initials: 'JR',
  text: 'Die Taktikkarten sind professionell wie aus der Bundesliga. Ich drucke sie aus und meine Spielerinnen verstehen sofort, was ich erkläre. Der Preis ist im Vergleich zum Wert ein Witz.',
  rating: 5,
  color: 'from-purple-500/20 to-purple-600/5',
  accent: 'border-purple-500/30'
}, {
  name: 'Andreas H.',
  role: 'Co-Trainer Herren, Stuttgart',
  initials: 'AH',
  text: 'Der 101 Pro Drills Archiv ist mein neuer bester Freund. Wenn ein Spieler ausfällt oder ich die Intensität schnell anpassen muss, habe ich in Sekunden eine Lösung. Absolute Empfehlung.',
  rating: 5,
  color: 'from-blue-500/20 to-blue-600/5',
  accent: 'border-blue-500/30'
}, {
  name: 'Lena F.',
  role: 'Trainerin U14, Frankfurt',
  initials: 'LF',
  text: 'Ich war skeptisch bei dem Preis — zu günstig, dachte ich. Aber die Qualität ist Wahnsinn. Mein Wochenende gehört wieder mir, und das Team trainiert effektiver als je zuvor.',
  rating: 5,
  color: 'from-secondary/20 to-yellow-500/5',
  accent: 'border-secondary/30'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 sm:py-24 px-4 relative overflow-hidden" data-id="element-223">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center top, rgba(37,99,235,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-224"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-225">
        <div className="text-center mb-14 sm:mb-20" data-id="element-226">
          <span className="inline-block bg-secondary/10 text-secondary border border-secondary/20 px-4 py-1.5 rounded-full font-bold text-xs sm:text-sm tracking-wider uppercase mb-5" data-id="element-227">
            ⭐ Über 800 verifizierte Bewertungen
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-228">
            Was Trainer über{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-229">
              Volleyball Bereit
            </span>{' '}
            sagen
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto font-medium" data-id="element-230">
            Echte Stimmen von Coaches aus ganz Deutschland — von der Jugend bis
            zur Bundesliga.
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-3 gap-4 sm:gap-8 mb-14 sm:mb-16 max-w-3xl mx-auto" data-id="element-231">
          <div className="bg-bg-alt border border-border-light rounded-2xl p-4 sm:p-6 text-center" data-id="element-232">
            <div className="text-2xl sm:text-4xl font-black text-primary mb-1" data-id="element-233">
              4.9/5
            </div>
            <div className="text-text-sec text-xs sm:text-sm font-medium" data-id="element-234">
              Bewertung
            </div>
          </div>
          <div className="bg-bg-alt border border-border-light rounded-2xl p-4 sm:p-6 text-center" data-id="element-235">
            <div className="text-2xl sm:text-4xl font-black text-cta-green mb-1" data-id="element-236">
              12.000+
            </div>
            <div className="text-text-sec text-xs sm:text-sm font-medium" data-id="element-237">
              Coaches
            </div>
          </div>
          <div className="bg-bg-alt border border-border-light rounded-2xl p-4 sm:p-6 text-center" data-id="element-238">
            <div className="text-2xl sm:text-4xl font-black text-secondary mb-1" data-id="element-239">
              98%
            </div>
            <div className="text-text-sec text-xs sm:text-sm font-medium" data-id="element-240">
              Empfehlen es
            </div>
          </div>
        </div>

        {/* Testimonial grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-241">
          {testimonials.map((t, i) => <div key={i} className={`bg-bg-alt border ${t.accent} rounded-2xl p-6 sm:p-7 flex flex-col relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300 shadow-xl`} data-id="element-242">
              {/* Subtle gradient overlay */}
              <div className={`absolute inset-0 bg-gradient-to-br ${t.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none`} data-id="element-243"></div>

              {/* Quote mark */}
              <span className="absolute top-3 right-4 text-6xl text-primary/10 font-serif leading-none pointer-events-none select-none" data-id="element-244">
                "
              </span>

              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4 relative z-10" data-id="element-245">
                {Array.from({
              length: t.rating
            }).map((_, idx) => <span key={idx} className="text-secondary text-base" data-id="element-246">
                    ★
                  </span>)}
              </div>

              {/* Text */}
              <p className="text-text-main text-base leading-relaxed font-medium mb-6 relative z-10 flex-1" data-id="element-247">
                {t.text}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/60 relative z-10" data-id="element-248">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-primary to-blue-600 flex items-center justify-center text-white font-black text-sm flex-shrink-0 shadow-[0_0_10px_rgba(37,99,235,0.3)]" data-id="element-249">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-250">
                  <div className="text-text-main font-bold text-sm flex items-center gap-1.5" data-id="element-251">
                    {t.name}
                    <span className="text-cta-green text-xs" title="Verifizierter Käufer" data-id="element-252">
                      ✓
                    </span>
                  </div>
                  <div className="text-text-sec text-xs font-medium truncate" data-id="element-253">
                    {t.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* CTA below */}
        <div className="text-center mt-14 sm:mt-16" data-id="element-254">
          <a href="#pricing" className="btn-primary-pulse inline-block bg-cta-green text-gray-900 font-black text-base sm:text-xl px-8 sm:px-10 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-255">
            🚀 ICH WILL AUCH DABEI SEIN
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium mt-4 flex items-center justify-center gap-2 flex-wrap" data-id="element-256">
            <span data-id="element-257">⚡ Sofortiger Zugriff</span>
            <span data-id="element-258">•</span>
            <span data-id="element-259">🛡️ 7 Tage Garantie</span>
          </p>
        </div>
      </div>
    </section>;
}